const B = 'https://khansayazidi.tn/assets/Robinetterie';
const DOUCHES = [{
    name: 'Douche Apparente Lines',
    folder: 'douches/douche apparente Lines',
    imgs: ['IMG_3533.webp', 'IMG_3467.webp', 'IMG_3456.webp', 'IMG_3558.webp', 'IMG_3580.webp'],
    material: `Douche apparente Lines avec cascade d'eau en laiton massif entièrement façonné à la main.`
  },
  {
    name: 'Douche Encastrée Curved',
    folder: 'douches/Douche encastrée Curved',
    imgs: ['douche_demi_lune1.webp', 'douche_demi_lune2.webp', 'douche_demi_lune3.webp'],
    material: `Douche demi Lune avec cascade d'eau en laiton massif entièrement façonné à la main Avec raccords et corps encastrables.`
  },
  {
    name: 'Douche Encastrée Lines',
    folder: 'douches/douche encastrée Lines',
    imgs: ['douche_rectangulaire1.webp', 'douche_rectangulaire2.webp', 'douche_rectangulaire3.webp'],
    material: `Douche Lines avec cascade d'eau en laiton massif entièrement façonné à la main Avec raccords et corps encastrables.`
  },
  {
    name: 'Douche Encastrée Summit',
    folder: 'douches/douche encastrée Summit',
    imgs: ['douche_triangulaire1.webp', 'douche_triangulaire2.webp'],
    material: `Douche Summit avec cascade d'eau en laiton massif entièrement façonné à la main Avec raccords et corps encastrables.`
  },
  {
    name: 'Mélangeur Douchette Lines',
    folder: 'douches/mélangeur pour douchette Lines',
    imgs: ['IMG_4533.webp', 'IMG_4541.webp', 'IMG_4548.webp'],
    material: ` `
  },
];
const MURAUX = [{
    name: 'Robinet Mural Cascade',
    folder: 'robinets muraux/Robinet mural Cascade',
    imgs: ['IMG_4077.webp', 'IMG_4061.webp', 'IMG_4030.webp', 'IMG_4110.webp', 'IMG_9549.webp'],
    material: `Robinet mural avec voile d'eau en laiton massif entièrement façonné à la main, avec raccords encastrable

Disponible en laiton doré et chromé.

Papillons au choix`
  },
  {
    name: 'Robinet Mural Curved',
    folder: 'robinets muraux/Robinet mural Curved',
    imgs: ['IMG_0690.webp', 'IMG_0736.webp', 'IMG_0755.webp', 'IMG_6487.webp', 'IMG_6496.webp', 'IMG_6627.webp', 'IMG_6680.webp', 'IMG_6693.webp'],
    material: `Robinet mural Curved en laiton massif entièrement façonné à la main, avec raccords encastrable

Disponible en laiton doré et chromé.

Papillons au choix`
  },
  {
    name: 'Robinet Mural Hammam',
    folder: 'robinets muraux/Robinet mural Hammam',
    imgs: ['robinets1.webp', 'robinets2.webp', 'robinets3.webp', 'robinets4.webp'],
    material: `Robinet mural Rayons en laiton massif entièrement façonné à la main, 

Disponible en laiton doré et chromé.

Papillons au choix`
  },
  {
    name: 'Robinet Mural Heritage',
    folder: 'robinets muraux/Robinet mural Heritage',
    imgs: ['IMG_3726.webp', 'IMG_3772.webp', 'IMG_3792.webp', 'IMG_3814.webp', 'IMG_3825.webp', 'IMG_8914.webp', 'IMG_8919.webp', 'IMG_8966.webp'],
    material: `Robinet mural avec Héritage en laiton massif entièrement façonné à la main, avec raccords apparents

Disponible en laiton doré et chromé.

Papillons au choix

`
  },
  {
    name: 'Robinet Mural Héritage Courbé',
    folder: 'robinets muraux/Robinet mural Héritage courbé',
    imgs: ['IMG_4164.webp', 'IMG_4173.webp', 'IMG_4183.webp'],
    material: ` `
  },
  {
    name: 'Robinet Mural Rayons',
    folder: 'robinets muraux/Robinet mural Rayons',
    imgs: ['robinet_mural_Rayons.webp', 'doodle1.webp', 'DSC_0238.webp', 'DSC_0352.webp', 'IMG_1945.webp', '003.webp'],
    material: `Robinet mural Rayons en laiton massif entièrement façonné à la main, avec raccords encastrable

Disponible en laiton doré et chromé.

Papillons au choix`
  },
];
const A_POSER = [{
    name: 'Robinet à Poser Arc',
    folder: 'robinets à poser/Robinet à poser Arc',
    imgs: ['07.webp', '08.webp', '11.webp', 'robinet_à_poser_lines_arc.webp', 'robinet_à_poser_lines_arc2.webp'],
    material: `Robinet à poser Lines Arc en laiton massif entièrement façonné à la main, avec raccords intégrés

Disponible en laiton doré et chromé.`
  },
  {
    name: 'Robinet à Poser Lines Carré',
    folder: 'robinets à poser/Robinet à poser Lines carré',
    imgs: ['IMG_1737.webp', 'IMG_3419.webp', 'robinet_à_poser_lines_carré1.webp', 'robinet_à_poser_lines_carré2.webp'],
    material: `Robinet à poser Lines carré en laiton massif entièrement façonné à la main, avec raccords intégrés

Disponible en laiton doré et chromé.`
  },
  {
    name: 'Robinet à Poser Lines Courbé',
    folder: 'robinets à poser/Robinet à poser Lines courbé',
    imgs: ['img7.webp', 'IMG_20241111_121711.webp', 'IMG_3235.webp', 'robinet_à_poser_courbé2.webp', 'robinet_à_poser_lines_arrondi.webp'],
    material: `Robinet à poser Lines courbé en laiton massif entièrement façonné à la main, avec raccords intégrés

Disponible en laiton doré et chromé.`
  },
  {
    name: 'Robinet à Poser Diadème',
    folder: 'robinets à poser/Robinet à poser diadéme',
    imgs: ['1779030180152.webp', '1779030180180.webp', '1779030180210.webp', '1779030180239.webp', '1779030180268.webp', '1779030180297.webp', '1779030180329.webp', '1779030180358.webp'],
    material: ` `
  },
  {
    name: 'Robinet à Poser Olea Aurea',
    folder: 'robinets à poser/Robinet à poser Olea Aurea',
    imgs: ['DSC07184.webp', 'DSC07192.webp', 'DSC07218.webp', 'DSC07219.webp'],
    material: 'Laiton Doré 24k',
    collection: 'Olea Aurea'
  },
  {
    name: 'Robinet à Poser Heritage',
    folder: 'robinets à poser/Robinet à poser Heritage',
    imgs: ['3.webp', '4.webp', 'IMG_2709.webp', 'IMG_2712.webp', 'IMG_5791.webp'],
    material: ` `,
    collection: 'Héritage'
  },
  {
    name: 'Robinet à Poser Curved',
    folder: 'robinets à poser/Robinet à poser Curved',
    imgs: ['IMG_2565.webp', 'IMG_4459.webp', 'IMG_1435.webp', 'IMG_1459.webp'],
    material: `Robinet à poser curved en laiton massif entièrement façonné à la main,

Disponible en laiton doré et chromé.`
  },
  {
    name: 'Robinet à Poser Curved Froid',
    folder: 'robinets à poser/Robinet à poser Curved froid',
    imgs: ['IMG_20221003_131017.webp', 'IMG_20240608_105101.webp', 'IMG_8352.webp'],
    material: `Robinet à poser curved en laiton massif entièrement façonné à la main,

Disponible en laiton doré et chromé.`
  },
  {
    name: 'Robinet à Poser Rustique',
    folder: 'robinets à poser/Robinet à poser Rustique',
    imgs: ['PSX_20230111_124517.webp', 'PSX_20230111_124853.webp', 'PSX_20230111_125522.webp'],
    material: ` `
  },
  {
    name: 'Robinet à Poser Summit',
    folder: 'robinets à poser/Robinet à poser Summit',
    imgs: ['1779031016880.webp', '1779031016910.webp', '1779031016940.webp', 'robinet_à_poser_triangulaire1.webp'],
    material: `Robinet à poser Summit en laiton massif entièrement façonné à la main, avec raccords à encastrer

Disponible en laiton doré et chromé.`
  },
  {
    name: 'Robinet à Poser Flipo',
    folder: 'robinets à poser/Robinet à poser Flipo',
    imgs: ['IMG_3961.webp', 'IMG_3974.webp', 'IMG_3982.webp', 'IMG_4041.webp'],
    material: ` `
  }, 
  {
    name: 'Robinet à Poser Déesse',
    folder: 'robinets à poser/Robinet à poser au Sol Déesse',
    imgs: ['DSC09878 (2).webp', 'DSC09915.webp', 'DSC09932.webp', 'DSC09939.webp'],
    material: ` `,
    collection: 'Déesse'
  },

];
const SUSPENDUS = [{
    name: 'Robinet Suspendu Curved',
    folder: 'Robinets suspendus/Robinet suspendu Curved',
    imgs: ['IMG_20251015_101218.webp', 'IMG_4093.webp', 'IMG_4097.webp', 'IMG_4109.webp', 'IMG_4117.webp', 'IMG_4121.webp'],
    material: ` `
  },
  {
    name: 'Robinet Suspendu Leaf',
    folder: 'Robinets suspendus/Robinet suspendu Leaf',
    imgs: ['IMG_6115.webp', 'IMG_6159.webp', 'IMG_6241.webp', 'IMG_6261.webp', 'IMG_6275.webp'],
    material: `Leaf,

Notre nouvelle création,

Notre nouvelle passion.

Le nouveau robinet suspendu pour lave main, Leaf

Une prouesse technique de 1m80,

En laiton massif alimentaire certifié sans plomb et entièrement façonné à la main,

Le fruit d'une semaine de travail manuel ininterrompu, leaf est sous garantie pendant cinq ans. `
  },
];
const WC = [{
    name: 'Robinet WC Lines Chaud-Froid',
    folder: 'Robinets WC/Robinet WC Lines chaud-froid',
    imgs: ['IMG_4680.webp', 'IMG_4688.webp', 'IMG_4728.webp'],
    material: ` `
  },
  {
    name: 'Robinet WC Lines Froid',
    folder: 'Robinets WC/Robinet WC Lines froid',
    imgs: ['IMG_4718.webp', 'IMG_4685.webp', 'IMG_4702.webp', 'IMG_3688.webp'],
    material: ` `
  },
];

// Add resolved URLs
const resolve = (items) => items.map(item => ({
  ...item,
  img: `${B}/${item.folder}/${item.imgs[0]}`,
  images: item.imgs.map(f => `${B}/${item.folder}/${f}`),
}));

export const douches = resolve(DOUCHES);
export const robinetsMuraux = resolve(MURAUX);
export const robinetsAPoser = resolve(A_POSER);
export const robinetsSuspendus = resolve(SUSPENDUS);
export const robinetsWC = resolve(WC);
export const allRobinetterie = [...douches, ...robinetsMuraux, ...robinetsAPoser, ...robinetsSuspendus, ...robinetsWC];